import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import {
  NavBar,
  ContentDisplay,
  ListDisplay,
  HeadingDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { formatCurrency } from '@/modules/common/helpers/currency';

interface Props {
  portfolioName: string;
  valueToInvest: number;
  loading: boolean;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'submit'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewTransactionDetails',
  props: {
    portfolioName: null,
    valueToInvest: null,
    loading: { type: Boolean }
  },
  emits: ["close", "submit"],
  setup(__props: any) {

const props = __props as {
  portfolioName: string;
  valueToInvest: number;
  loading: boolean;
}





const valueToInvestFormatted = computed(
  () => 'R$ ' + formatCurrency(props.valueToInvest)
);

return { __sfc: true,props, valueToInvestFormatted, NavBar, ContentDisplay, ListDisplay, HeadingDisplay, ButtonContainer, ButtonPrimary, BackButton }
}

})